try {
    window.$ = window.jQuery = require('jquery');

    //media query breakpoints
    require('@bit/apollo-web-services.pattern-library.media-query-breakpoints/mq_breakpoints.js');

    //bootstrap
    require('bootstrap/dist/js/npm.js');

    //anchor smooth scroll
    require('@bit/apollo-web-services.pattern-library.anchor-smooth-scroll/anchor-smooth-scroll.js');

    //custom form select formatting
    require('@bit/apollo-web-services.pattern-library.forms/forms.js');

    //google analytics event tracking
    require('@bit/apollo-web-services.pattern-library.ga-event-tracking/ga-event-tracking.js');

} catch (e) {}